<template>
    <div v-if="dataSource" class="p-relative">

        <Toolbar                         
            v-on:toolbar-button-click="onToolbarClick"  
        > 
            <!--Панель поиска-->
            <SearchPanel
                v-model="search"
                :has-filter="true"
                @on-filter-click="onFilterClick"
            />
        </Toolbar>

        <FilterPanel
            v-if="filterDataSource"
            :dataSource="filterDataSource"
            v-bind:status.sync="category"
            v-bind:substatus.sync="status"
            v-bind:year.sync="completeYear"
        >
            <ExtendedFilterPanel
                v-if="$helpers.isExtendedFilterPanelVisible(extendedTableFilter)"
                v-bind:value.sync="extendedTableFilter"
            />
        </FilterPanel>

        <v-row no-gutters>
            <v-col cols="12" xs="12" md="12">
                <v-data-table
                    :headers="headers"
                    :loading="loading"
                    :items="entities"
                    :item-class="itemRowBackground"
                    :options.sync="options"
                    :server-items-length="total"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions:[ 5, 10, 20] }"
                    :page.sync="options.page"
                    @page-count="paginationPageCount = $event"
                    class="elevation-1 customization-list-table pagination-list-table sticky-table"
                    @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.id, type: 'Chancellery|Documents|CitizenStatements.Document' })"
                >
                    <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                    <template v-slot:[`item.regdate`]="{ item }">
                        {{ dateFormat(item.regdate, 'DD.MM.YYYY') }}
                    </template>

                    <template v-slot:[`item.recdate`]="{ item }">
                        {{ dateFormat(item.recdate, 'DD.MM.YYYY') }}
                    </template>

                    <template v-slot:[`item.execdate`]="{ item }">
                        {{ dateFormat(item.execdate, 'DD.MM.YYYY') }}
                    </template>

                    <template v-slot:[`item.registrationstate`]="{ item }">
                        <StatusChip :status="getStatus(item)"/>
                    </template>

                    <template v-slot:[`item.declarant`]="{ item }">
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.declarant">
                                {{ item.declarant }}
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.annotation`]="{ item }">
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.annotation">
                                {{ item.annotation }}
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.commentstate`]="{ item }">
                        <div class="icon-with-badge">
                            <v-icon v-if="item.commentstate" v-tooltip.top-center="$t('Есть_комментарии')" class="has-unreaded-comments">
                                fas fa-comment-alt
                            </v-icon>
                            <span v-if="item.commentstate" v-tooltip.top-center="$t('Есть_комментарии')" class="badge">
                                {{ item.commentstate > 99 ? '99+' : item.commentstate }}
                            </span>
                        </div>
                    </template>

                    <template v-slot:[`footer.prepend`]>
                        <v-pagination
                            v-model="options.page"
                            :length="paginationPageCount"
                            :total-visible="$listPaginationTotal"
                            color="teal"
                        ></v-pagination>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>

        <QalaQyzmetRequestsExFilterDlg
            v-model="extendedTableFilter" 
            ref="QalaQyzmetRequestsExFilterDlgRef" 
        />

    </div>
</template>

<script>
import Axios from 'axios';
import _ from 'lodash';
import { httpAPI } from "@/api/httpAPI";
import sys from "@/services/system";
import { mapActions, mapGetters } from 'vuex';
import Toolbar from '@/components/documents/Toolbar.vue';
import StatusChip from '@/components/global/chips/StatusChip';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import FilterPanel from '@/components/qala-qyzmet/FilterPanel3Level.vue';
import ExtendedFilterPanel from '@/components/documents/ExtendedFilterPanel.vue';

import QalaQyzmetRequestsExFilterDlg from '@/components/qala-qyzmet/dialogs/extended-filters/Requests.vue';

export default {
    name: "QalaQyzmetRequests",
    components: {
        Toolbar,
        StatusChip,
        SearchPanel,
        FilterPanel,
        ExtendedFilterPanel,        
        QalaQyzmetRequestsExFilterDlg
    },
    data () {
        return {
            loading: true,
            cancellationTokenSorce: null,

            dataSource: null,
            filterDataSource: null,

            total: 0,
            entities: [],
            prevTableFilterObject: null,
            paginationPageCount: 0
        }
    },
    computed: {
        ...mapGetters('documents/references', { avaibleStatuses: 'GetAvaibleStatuses' }),
        collection () {
            return "Documents.CSC";
        },
        category: {
            get: function() {
                return this.$store.getters['qalaQyzmet/requests/getCategory'];
            },
            set: function(newValue) {
                this.resetPage();
                this.$store.commit('qalaQyzmet/requests/SET_CATEGORY', newValue);
            }
        },
        status: {
            get: function() {
                return this.$store.getters['qalaQyzmet/requests/getStatus'];
            },
            set: function(newValue) {
                this.resetPage();
                this.$store.commit('qalaQyzmet/requests/PUSH_STATUS', newValue);
            }
        },
        completeYear: {
            get: function() {
                return this.$store.getters['qalaQyzmet/requests/getYear'];
            },
            set: function(newValue) {
                this.resetPage();
                this.$store.commit('qalaQyzmet/requests/PUSH_YEAR', newValue);
            }
        },
        headers() {
            const headers = [
                { text: this.$t('Рег._номер'), value: 'regnumber', width: '150px', orderby: 2 },
                { text: this.$t('Рег._дата'), value: 'regdate', width: '120px', orderby: 3 },                    
                { text: this.$t('ИИН/БИН'), value: 'iin_bin', width: '120px', orderby: 13 },
                { text: this.$t('Заявитель'), value: 'declarant', width: '15%', orderby: 6 },
                { text: this.$t('Услуга'), value: 'annotation', orderby: 12 },
                { text: this.$t(''), value: 'commentstate', orderby: 26, width: '50px',sortable: false },
                { text: this.$t('Исх._№_заявления'), value: 'uniquenumber', width: '170px', orderby: 22 },                
                { text: this.$t('Дата_создания'), value: 'recdate', width: '130px', orderby: 21 },
                { text: this.$t('Дата_исполнения'), value: 'execdate', width: '160px', orderby: 14 },
                { text: this.$t('Статус'), value: 'registrationstate', width: '100px', orderby: 16, sortable: false }
            ];

            if (["OnRegistration"].includes(this.category)) {
                return headers.filter(h => !['regnumber', 'regdate', 'registrationstate', 'execdate'].includes(h.value))
            }
            else if (["Completed"].includes(this.category)) {
                return headers.filter(h => !['recdate'].includes(h.value))
            }
            else {
                return headers.filter(h => !['recdate', 'execdate'].includes(h.value))
            }
        },
        options: {
            get: function() {
                return this.$store.getters['qalaQyzmet/requests/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('qalaQyzmet/requests/SET_TABLE_OPTION', newValue);
            }
        },
        search: {
            get: function() {
                return this.$store.getters['qalaQyzmet/requests/getSearch'];
            },
            set: _.debounce(function(newValue) {
                this.resetPage();
                this.$store.commit('qalaQyzmet/requests/SET_SEARCH', newValue);
            }, 250),
        },
        extendedTableFilter: {
            get: function() {
                return this.$store.getters['qalaQyzmet/requests/getExtendedFilter'];
            },
            set: function(newValue) {
                this.resetPage();
                this.$store.commit('qalaQyzmet/requests/SET_EXTENDED_FILTER', newValue);
            }
        },        
        filter () {
            return {
                ...this.options,
                SearchStr: this.search,
                Category: this.category,
                ArchYear: this.completeYear,
                RequestStatus: this.status,
                extendedFilterData: this.$helpers.getOnlySelectedParams(this.extendedTableFilter)
            }
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        dateFormat: sys.dateFormat,
        getStatus(item) {
            let key = '';
            
            if (item.registrationstate == 1 && item.executionstatus == 0 && item.paymentstatus != 2 && ![1, 2].includes(item.signaturestatus) &&  !item.hasrecipients && !item.hasresolutions) key = 'acepted'; //принят            
            if (item.registrationstate == 1 && item.executionstatus == 0 && item.paymentstatus != 2 &&  ![1, 2].includes(item.signaturestatus) && item.hasrecipients && !item.hasresolutions) key = 'consideration';
            if (item.paymentstatus == 2 && ![1, 2].includes(item.signaturestatus)) key = 'waitPayment';
            if (item.paymentstatus == 3 && ![1, 2].includes(item.signaturestatus)) key = 'paymentMade';
            if (item.registrationstate == 1 && item.executionstatus == 0 && item.paymentstatus != 2 && ![1, 2].includes(item.signaturestatus) && item.hasresolutions) key = 'onExecution';
            if (item.signaturestatus == 1) key = 'onSignatureOfApplicant';
            if (item.signaturestatus == 2) key = 'onSignatureOfServiceProvider';
            if (item.executionstatus == 1) key = 'executed';
            if (item.executionstatus == 2) key = 'refusal';
            if (item.registrationstate == 1 && item.receptionstatus == 1) key = 'waiting_reception'

            return this.avaibleStatuses[key];
        },
        resetPage() {
            this.$store.commit('qalaQyzmet/requests/SET_TABLE_OPTION_PAGE', 1);
        },
        itemRowBackground (item) {
            return item.readed === true ? '' : 'font-weight-bold';
        },
        async loadButtons() {
            this.setOverlayVisible({ visible: true });
            
            let response = await httpAPI({
                url: `api/actions/collection?type=${this.collection}`,
                method: 'GET'
            });

            if (response) {
                await this.loadFilters();
                this.dataSource = response.data.Payload;
                this.$store.commit('documents/toolbar/SET_MENU', { menu: this.dataSource.Data.Menu });
            }
            
            this.setOverlayVisible({ visible: false });
        },
        async loadFilters() {
            let filterResponse = await httpAPI({
                url: `api/csc/requests/filter`,
                method: 'GET'
            });

            if (filterResponse) {
                this.filterDataSource = filterResponse.data.Payload;
            }
        },
        async getData (isRefresh = false) {
            let tableFilterObject = this.getTableFilterObject();

            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, tableFilterObject))
                return;

            if (tableFilterObject.Category == "Completed" && tableFilterObject.ArchYear == "0")
                return;

            this.prevTableFilterObject = tableFilterObject;
            this.total = 0;
            this.entities = [];
            this.loading = true;

            if (this.cancellationTokenSorce)
                this.cancellationTokenSorce.cancel('New request started');

            this.cancellationTokenSorce = Axios.CancelToken.source();

            let response = await httpAPI({
                url: `api/csc/requests/list?filter=${JSON.stringify(tableFilterObject)}`,
                method: 'GET',
                cancelToken: this.cancellationTokenSorce.token,
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            this.loading = false;
        },
        getTableFilterObject() {
            var { sortBy, sortDesc, page, itemsPerPage, SearchStr, Category, ArchYear, RequestStatus, extendedFilterData } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let OrderBy = this.headers.find(i => i.value == (sortBy.length <= 0 ? 'null' : sortBy[0]))?.orderby ?? -1;

            if (Array.isArray(OrderBy))
                OrderDir = OrderBy.map(() => OrderDir);
            
            if (["Completed"].includes(this.filter.Category))
                return { Category, ArchYear, RequestStatus, SearchStr, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage, ...extendedFilterData }

            return { Category, RequestStatus, SearchStr, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage, ...extendedFilterData };
        },        
        async onFilterClick() {
            try
            {
                await this.$refs.QalaQyzmetRequestsExFilterDlgRef.open()
            }
            catch (ex)
            {
                if (ex.isCancelled) 
                    console.warn(ex.message);
                else
                    console.error(ex.message);
            }
        },        
        onToolbarClick(event, btn) {
            let method = this[btn.Action];

            if (method)
                method(btn);
            else
                this.$notify.alert(`Действие ${btn.Action} не реализовано`);
        },
        async Refresh() {
            await this.loadFilters();
            await this.getData(true);
        },
        async Export() {
            let filter = this.getTableFilterObject();
            delete filter.Limit;
            delete filter.Offset;
            let exportURI = `api/csc/requests/export?filter=${JSON.stringify(filter)}`;
            this.$eventBus.$emit('on-get-report', { url: exportURI, text: `${this.$t("Экспорт_списка_заявок")} ${this.$t('от_время')} ${this.$moment().format('DD.MM.YYYY HH.mm.ss')}`, type: 'Xls' });
        },
    },
    watch: {
        filter: {
            handler () {
                this.getData()
            },
            deep: true,
        }
    },
    async created() {
        this.loadButtons();
    }
}
</script>